import {
	START_LOGIN,
	LOGIN_FAILURE,
	LOGIN_SUCCESS,
	RESET_ERROR,
	SIGN_OUT_SUCCESS
} from "./constants";

import initialState from "./initialState";

export default (state = initialState, action) => {
	switch (action.type) {
		case START_LOGIN:
			return {
				...state,
				isLoading: true
			};
		case LOGIN_SUCCESS:
			return {
				...state,
				isLoading: false,
				isAuthenticated: true,
				error: null
			};
		case LOGIN_FAILURE:
			return {
				...state,
				isLoading: false,
				error: true
			};
		case RESET_ERROR:
			return {
				error: false
			};
		case SIGN_OUT_SUCCESS:
			return {
				...state,
				isAuthenticated: false
			};
		default:
			return state;
	}
};
